module.exports = __webpack_public_path__ + "img/case8.14f59844.png";